import React from 'react';
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import SmallTitle from '../Components/SmallTitle';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import SchoolIcon from '@material-ui/icons/School';
import ResumeItem from '../Components/ResumeItem';

function Resume() {
    const briefcase = <BusinessCenterIcon />
    const school = <SchoolIcon />
    return (
        <ResumeStyled>
            <Title title={'Experience'} span={'Experience'} />
            <InnerLayout>
                <div className="small-title">
                    <SmallTitle icon={briefcase} title={'Work Experience'} />
                </div>
                <div className="resume-content">

                    <ResumeItem
                        year={'Mar 2022 - Present'}
                        title={'Software Developer'}
                        subTitle={'Lumient ; Adelaide'}
                        text={'- Responsible for the design and implementation of the architecture behind a Totally Automated comprehensive web-based management system.'}
                        text1={'- For a major players and companies in the Wool Production industry.'}
                        text2={'- The system is a single page application built on the latest technologies such as .NET, ASP.NET Core, Entity Framework and Vue.JS'}
                    />
                    <ResumeItem
                        year={'Dec 2021 - Feb 2022'}
                        title={'Software Engineer'}
                        subTitle={'ACURA Group Australia Pty Ltd ; Adelaide'}
                        text={'- In charge of renovating large-scale eCommerce website of Highgate Air for highly performant customer-experience using Magento.'}
                        text1={'- Undertaking the entire control of the eCommerce website and the mobile application which is being built by me in React-Native.'}
                        text2={'- Also, lead in API development for robust software development and better Code quality in an Agile environment.'}
                    />
                    <ResumeItem
                        year={'Sep 2021 - Nov 2021 '}
                        title={'Full Stack Web Developer Intern'}
                        subTitle={'eBottli ; Adelaide'}
                        text={'- Responsible for making a Digitalise Full Stack Asynchronous Wine Shopping web application for official Winegrapes Australia.'}
                        text1={'- Committed in order to build the project by myself and working hand in glove with the Stakeholders and other Software Developers.'}
                        text2={'- Developing the web application from scratch and using Angular 12 for Front-end and Google Firebase as the Database. '}
                        text3={''}
                        text4={''}
                        text5={''}
                    />
                    <ResumeItem
                        year={'Jun 2021 - Aug 2021 '}
                        title={'Full Stack Web Developer Intern'}
                        subTitle={'Colakin ; Melbourne'}
                        text={'- Supervised Artificial intelligence APIs for solving size problems in the clothing industry.'}
                        text1={'- Took complete ownership of the existing platform and developing high-quality and maintainable Microservices and RESTful APIs.'}
                        text2={'- Working closely with front-end developers, internal testers and product teams to understand new requirements and deliverables.'}
                        text3={'- Constructing it by Vue JS, Spring Boot, Node JS, Python, Mongo DB and Graph QL. '}
                    />
                    <ResumeItem
                        year={'Mar 2021 - May 2021 '}
                        title={'Full Stack Web Developer Intern'}
                        subTitle={'Accede Holdings Pty Ltd ; Adelaide'}
                        text={'-  Delivered a new web-based front face for the Royal Adelaide Hospital with its existing client’s databases.'}
                        text1={'- Review the MS Access forms and then created a HTML and PHP version of these forms to be hosted on Amazon AWS.'}
                        text2={'- Rebuilt the entire website with up-to-date technologies and frameworks which improved the internal operating efficiency by 40%.'}
                    />
                    <ResumeItem
                        year={'Jan 2021 - Present'}
                        title={"Parson’s Puzzle Student Researcher"}
                        subTitle={'The University of Adelaide'}
                        text={'- Working to build software where the program’s code can be shuffled into puzzles, we have to join them to make a working program. '}
                        text1={'- Assigned to categorised and built the puzzles with the integration of concepts, Cognitive load and Bloom’s taxonomy.'}
                        text2={'- Also, did the testing of the entire software to ensure there is bug-free code which will be helpful for the code reuse in future.'}
                    />
                </div>
                <div className="small-title u-small-title-margin">
                    <SmallTitle icon={school} title={'Education'} />
                </div>
                <div className="resume-content ">
                    <ResumeItem
                        year={'2020 - Present'}
                        title={"Bachelor of Computer Science"}
                        subTitle={'The University of Adelaide'}
                        text={'- GPA: 6.0 / 7.0'}
                        text1={'......................................................................................................................................'}
                        text2={'- Majoring in Artificial Intelligence and Data Science'}
                        text3={'- Global Citizen Scholarship of Excellence in Year 12'}
                        text4={'- Expected Graduation on November 2022'}
                    />
                    {/* <ResumeItem
                        year={'2018 - 2020'}
                        title={'CBSE 12 Science'}
                        subTitle={'Sudhir Memorial Institute'}
                        text={'- Central Board of Secondary Education (Class XII), '}
                        text1={'- with Computer Science, Maths, Physics, Chemistry, English as subjects'}
                        text2={'- Aggregate: 90%'}
                        text3={''}
                        text4={''}
                        text5={''}
                    />
                    <ResumeItem
                        year={'2016 - 2017'}
                        title={'ICSE 12 Science'}
                        subTitle={'Methodist School Dankuni'}
                        text={'- Indian Certificate of Secondary Education (Class X)'}
                        text1={'- with Computer Science, Maths, Physics, Chemistry, English as subjects'}
                        text2={'- Percentage: 90%'}
                        text3={''}
                        text4={''}
                        text5={''}
                    /> */}
                </div>
            </InnerLayout>
        </ResumeStyled>
    )
}

const ResumeStyled = styled.section`
    .small-title{
        padding-bottom: 3rem;
    }
    .u-small-title-margin{
        margin-top: 4rem;
    }

    .resume-content{
        border-left: 2px solid var(--border-color);
    }
`;
export default Resume
